class CollectionsTabs extends HTMLElement {
  constructor() {
    super();
    this.detailsList = this.querySelectorAll(".cstm-collections-tabs--details details");
    this.collectionsLists = this.querySelectorAll(".cstm-collections--collection");
    this.collectionsContents = this.querySelector(".cstm-collections-tabs--collections");
    
    this.handleResize = this.handleResize.bind(this);
    this.handleTabClick = this.handleTabClick.bind(this);
    this.handleMobileTabClick = this.handleMobileTabClick.bind(this);
  }

  connectedCallback() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
    

    if (this.detailsList.length > 0) {
      const firstTab = this.detailsList[0].dataset.id;
      this.chooseTab(firstTab);
    }
  }

  handleResize() {
    this.removeAllEventListeners();
    
    if (window.innerWidth > 1000) {
      this.setupDesktop();
    } else {
      this.setupMobile();
    }
  }

  removeAllEventListeners() {
    this.detailsList.forEach(el => {
      el.removeEventListener('click', this.handleTabClick);
      el.removeEventListener('click', () => this.handleMobileTabClick(el));
    });
  }

  setupDesktop() {
    if (this.collectionsContents) {
      this.collectionsContents.style.display = '';
    }
    
    this.detailsList.forEach(el => {
      el.addEventListener('click', this.handleTabClick);
    });
  }

  setupMobile() {
    if (this.collectionsContents) {
      this.collectionsContents.style.display = 'none';
    }
    
    this.detailsList.forEach(el => {
      el.querySelector('summary').addEventListener('click', () => this.handleMobileTabClick(el));
    });
  }

  handleTabClick(event) {
    const el = event.currentTarget;
    this.chooseTab(el.dataset.id);
  }

  handleMobileTabClick(el) {
    this.clearOtherOpenDetails(el.dataset.id);
    this.scrollToEl(el);
  }

  chooseTab(id) {
    if (!id) return;
    
    this.detailsList.forEach(el => {
      const isSelected = el.dataset.id === id;
      el.classList.toggle('open', isSelected);
      el.open = isSelected;
    });
    
    this.collectionsLists.forEach(el => {
      el.classList.toggle('open', el.dataset.id === id);
    });
  }

  clearOtherOpenDetails(id) {
    if (!id) return;
    
    this.detailsList.forEach(el => {
      if (el.dataset.id !== id) {
        el.open = false;
      }
    });
  }

  scrollToEl(el) {
    if (!el) return;
    
    const offset = document.querySelector('.cstm-header').scrollHeight + 20; 
    const elementRect = el.getBoundingClientRect();
    const absoluteElementTop = elementRect.top + window.pageYOffset;
    
    window.scrollTo({
      top: absoluteElementTop - offset,
      behavior: 'smooth'
    });
  }
}

customElements.define("collections-tabs", CollectionsTabs);